/* eslint-disable no-param-reassign */
// Adapted from https://github.com/hijonathan/moment.twitter

import moment from 'moment';

const second = 1e3;
const minute = 6e4;
const hour = 36e5;
const day = 864e5;
const week = 6048e5;

const formats = {
  seconds: {
    short: 's',
    long: ' sec'
  },
  minutes: {
    short: 'm',
    long: ' min'
  },
  hours: {
    short: 'h',
    long: ' hr'
  },
  days: {
    short: 'd',
    long: ' day'
  }
};

function initialize(originalMoment) {
  function twitterFormat(format) {
    const diff = Math.abs(this.diff(originalMoment()));
    let unit = null;
    let num = null;
    if (diff <= second) {
      unit = 'seconds';
      num = 1;
    } else if (diff < minute) {
      unit = 'seconds';
    } else if (diff < hour) {
      unit = 'minutes';
    } else if (diff < day) {
      unit = 'hours';
    } else if (format === 'short') {
      if (diff < week) {
        unit = 'days';
      } else {
        return this.format('M/D/YY');
      }
    } else {
      return this.format('MMM D');
    }
    if (!(num && unit)) {
      num = originalMoment.duration(diff)[unit]();
    }
    let unitStr = unit = formats[unit][format];
    if (format === 'long' && num > 1) {
      unitStr += 's';
    }
    const suffix = !this.isAfter() ? ' ago' : '';
    return num + unitStr + suffix;
  }

  originalMoment.fn.twitterLong = function twitterLong() {
    return twitterFormat.call(this, 'long');
  };

  originalMoment.fn.twitterShort = function twitterShort() {
    return twitterFormat.call(this, 'short');
  };

  return originalMoment;
}

export default initialize(moment);



/** WEBPACK FOOTER **
 ** ./src/utils/moment-twitter.js
 **/